import LoaderIcon from "@Icons/LoaderIcon";
import styles from "./DropdownLoader.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";

const DropDownLoader = () => (
  <div className={styles.dropdownLoader}>
    <LoaderIcon />
  </div>
);

export default wrapperHOC(DropDownLoader, {
  componentName: "DropdownLoader-Global",
  showForChina: true,
});
